import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { shortKey } from "apps-module/app/shared-library/utils/common.utils";

@Component({
    selector: "[pcg-ng-boolean-dropdown-filter]",
    templateUrl: "./boolean-dropdown-filter.component.html"
})
export class BooleanDropdownFilterComponent implements OnInit {

    public control: FormControl<boolean> = null;
    @Input("control")
    public set controlSetter(value: FormControl<boolean>) {
        this.control = value;
    }

    public id: string = null;

    public ngOnInit(): void {
        this.id = shortKey();
    }

    @Input()
    public values: Array<boolean> = [];

    @Input()
    public label: string = null;

    @Output()
    public onSubmit = new EventEmitter();

    public submit(): void {
        this.onSubmit.emit();
    }
}
